import { useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propTextField, propTinyMceEditor } from "../../common/entityStoreForm";
import { propLengthMax, propRequired } from "../../common/entityStoreValidators";
import { PrintTemplateEditDto, newPrintTemplate } from "./types";

export const PrintTemplateDialog = (props: {
    close: () => void;
    printTemplate: PrintTemplateEditDto | null;
    onChange(): void;
}) => {
    const [{ usePrintTemplateDialogStore }] = useState(() => {
        const usePrintTemplateDialogStore = createEntityStore<PrintTemplateEditDto>({
            data: props.printTemplate === null ? newPrintTemplate() : { ...props.printTemplate },
            path: "settings/printTemplates",
            fetchOnInit: false,
            id: props.printTemplate != null ? props.printTemplate.id : null,
            getNewId: p => p.id!,
            onSaved() {
                props.onChange();
                props.close();
            },
            propValidators: [
                propRequired("name"),
                propLengthMax("name", 128),
            ]
        });

        return { usePrintTemplateDialogStore };
    });
    const { save, isSaveDisabled } = usePrintTemplateDialogStore(p => ({ save: p.save, id: p.entityId, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{props.printTemplate === null ? `New print template ` : `Edit print template - ${props.printTemplate?.name}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container>
                <Grid item xs={12}>{propTextField(usePrintTemplateDialogStore)("name", "Name",)}</Grid>
                <Grid item xs={12}>{propTinyMceEditor(usePrintTemplateDialogStore)("template", "Template",)}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};